var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('vx-card',{attrs:{"title":"System Pick List Manage"}},[_c('vs-list')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }